// import ModalGeneric from "  ./_add_popup/_component";

import ModalGeneric from 'modules/my-sales/submodules/leads/list/widgets/ModalGenericPopup';
import { useShippingPendingFooter } from './_hook';

const ShippingPendingFooterComponent = () => {
  const {
    modalOpen,
    cleanChannelLead,
    cleanCreateLead,
    setModalOpen,
    createLeadObj,
    selectChannel,
    setSelectChannel,
    CreateLead,
    setDropdownOptionsChannels,
    dropdownOptionsChannels,
  } = useShippingPendingFooter();

  return (
    <>
      {modalOpen && (
        <ModalGeneric
          cleanChannelLead={cleanChannelLead}
          cleanCreateLead={cleanCreateLead}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          createLeadObj={createLeadObj}
          selectChannel={selectChannel}
          setSelectChannel={setSelectChannel}
          CreateLead={CreateLead}
          setDropdownOptionsChannels={setDropdownOptionsChannels}
          dropdownOptionsChannels={dropdownOptionsChannels}
        />
      )}
    </>
  );
};

export default ShippingPendingFooterComponent;
